<template>
  <div>
    <div class="mb-4 flex justify-content-between align-items-center">
      <span v-if="id > 0" class="pr-2 mr-2 font-bold text-2xl"
        >Purchase Order - Edit</span
      >
      <span v-else class="pr-2 mr-2 font-bold text-2xl"
        >Purchase Order - Tambah</span
      >
      <div>
        <i class="pi pi-home mr-2"></i>
        <span v-if="id > 0" class="font-small"
          >/ Penjualan / Purchase Order / Edit</span
        >
        <span v-else class="font-small"
          >/ Penjualan / Purchase Order / Tambah</span
        >
      </div>
    </div>
    <form-purchase-order :id="id" />
  </div>
</template>

<script>
import FormPurchaseOrder from '@/components/pembelian/FormPurchaseOrder'

export default {
  components: {
    FormPurchaseOrder,
  },
  data() {
    return {
      id: parseInt(this.$route.params.id),
    }
  },
}
</script>
